import React, { useEffect, useState } from "react";
import combinedServices from "../../shared/services/user-service";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { NavLink, useParams } from "react-router-dom";
import Swal from "sweetalert2";

export default function IncompletePaymentEntries() {
  const [incompletePaymentEntries, setIncompletePaymentEntries] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const params = useParams();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await combinedServices.getFailedPaypalEntries(params.id);
        if (res && res.data && res.data.participants) {
          setIncompletePaymentEntries(res.data.participants);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load incomplete payment entries',
        });
      }
    }
    fetchData();
  }, [params.id]);

  

  const handleMarkCompleted = async (id) => {
    try {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "You are about to mark this payment as completed",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, mark as completed!'
      });

      if (result.isConfirmed) {
        setIsProcessing(true);
        const res = await combinedServices.markUserEntryCompleted({
          id: id,
          payment_status: "SUCCESS"
        });

        if (res && res.data) {
          // Update the local state to reflect the change
          setIncompletePaymentEntries(prevEntries => 
            prevEntries.map(entry => 
              entry.id === id ? { ...entry, payment_status: "SUCCESS" } : entry
            )
          );

          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Payment status updated to completed',
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          throw new Error('Invalid response from server');
        }
      }
    } catch (err) {
      console.error("Error updating payment status:", err);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to update payment status',
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="hd">Incomplete Payment Entries</div>
      </div>

      {incompletePaymentEntries.length > 0 ? (
        <Accordion allowZeroExpanded="true" preExpanded={[0]}>
          {incompletePaymentEntries
            .sort((a, b) =>
              a.user.user_firstname.localeCompare(b.user.user_firstname)
            )
            .map((value, index) => {
              const allClassesCancelled = value.classes?.every(
                (cls) => cls.participation_status === "CANCELLED"
              );

              return (
                !allClassesCancelled && (
                  <div key={index}>
                    <AccordionItem uuid={index}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          <div className="accQ d-flex justify-content-between">
                            <div className="d-flex col-12 justify-content-between align-items-center">
                              <NavLink
                                to={`/race-result-profile/${value.user.id}`}
                              >
                                {value.user.user_firstname +
                                  " " +
                                  value.user.user_lastname}
                              </NavLink>
                              <div className="d-flex align-items-center">
                                {value.payment_status === "PENDING" ? (
                                  <button
                                    className="entriesButtonEdit me-2"
                                    onClick={() => handleMarkCompleted(value.id)}
                                    disabled={isProcessing}
                                  >
                                    {isProcessing ? 'Processing...' : 'Mark as Completed'}
                                  </button>
                                ) : (
                                  <button 
                                    className="entriesButtonEdit me-2"
                                  >
                                    Completed
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <div className="acctable incomplete-payment-entries">
                          <table>
                            {value.classes?.map(
                              (cls, index) =>
                                cls.participation_status !== "CANCELLED" && (
                                  <tr key={cls.transponder_id}>
                                    {cls.transponder_id !== 0 ? (
                                      <table className="userinfo">
                                        <tbody>
                                          <tr>
                                            <td>{cls.class?.name}</td>
                                            <td>{cls.transponder_id}</td>
                                            <td>{cls.transponder_name}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    ) : (
                                      <td className="cancelled-classes-entries">
                                        {cls.class?.name}
                                      </td>
                                    )}
                                  </tr>
                                )
                            )}
                          </table>
                        </div>
                      </AccordionItemPanel>
                    </AccordionItem>
                  </div>
                )
              );
            })}
        </Accordion>
      ) : (
        <div className="no-entries">No incomplete payment entries found.</div>
      )}
    </div>
  );
}